export default [
  {
    path: '/v2',
    name: 'v2_experiments',
    component: () => import('@/views/v2/modules/skeleton/Home.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiments',
          active: true,
        },
      ],
    },
  },
  {
    path: '/v2/experiment-details/:id',
    name: 'v2_experiment_details',
    component: () => import('@/views/v2/modules/skeleton/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true
        },
      ],
    },
  },
  {
    path: '/v2/experiment-details/:id',
    name: 'v2_experiment_details_1',
    component: () => import('@/views/v2/modules/skeleton/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true
        },
      ],
    },
  },
  {
    path: '/v2/experiment-details/:id',
    name: 'v2_experiment_details_2',
    component: () => import('@/views/v2/modules/skeleton/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true
        },
      ],
    },
  },
  {
    path: '/v2/experiment-details/:id',
    name: 'v2_experiment_details_3',
    component: () => import('@/views/v2/modules/skeleton/ExperimentDetails.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Experiment Details',
          active: true,
          back: true
        },
      ],
    },
  },
  {
    path: '/v2/blank1',
    name: 'v2_blank1',
    component: () => import('@/views/v2/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v2/blank2',
    name: 'v2_blank2',
    component: () => import('@/views/v2/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v2/blank3',
    name: 'v2_blank3',
    component: () => import('@/views/v2/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v2/blank4',
    name: 'v2_blank4',
    component: () => import('@/views/v2/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v2/blank5',
    name: 'v2_blank5',
    component: () => import('@/views/v2/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v2/blank6',
    name: 'v2_blank6',
    component: () => import('@/views/v2/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v2/blank7',
    name: 'v2_blank7',
    component: () => import('@/views/v2/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v2/blank8',
    name: 'v2_blank8',
    component: () => import('@/views/v2/modules/skeleton/Blank.vue'),
    meta: {
      breadcrumb: [
        {
          text: '',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/v2/profile',
    name: 'v2_pages_profile',
    component: () => import('@/views/v2/modules/skeleton/Profile.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'My Experiments',
          active: true,
        },
      ],
    },
  },
]
